import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { lastValueFrom } from 'rxjs';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { ValidFeature } from '../../../../Model/ValidFeature';
import { TranslateService } from '@ngx-translate/core';
import DataSource from 'devextreme/data/data_source';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';

@Component({
    selector: 'userAction-deleteFeatures',
    templateUrl: 'userAction-deleteFeatures.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionDeleteFeaturesComponent) }
    ],
    standalone: false
})
export class UserActionDeleteFeaturesComponent extends UserActionBaseComponent {
  isLoading: boolean = true;

  features: DataSource;
  selectedFeatures: ValidFeature[];

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    private validFeatureService: ValidFeatureService,
    public systemService: SystemService
  ) {
    super(loginService,macroService);
    this.isLoading = true;
    this.loadFeatureNames().then(() => (this.isLoading = false));
  }

  async loadFeatureNames() {
    let validFeatures = await lastValueFrom(
      this.validFeatureService.getCatalogFeatures(
        this.catalogService.selectedCatalogId,
        this.loginService.currentUser.customerId
      )
    );
    this.features = new DataSource({
      store: validFeatures,
      paginate: true,
      pageSize: 10
    });
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.selectedFeatures == null || this.selectedFeatures.length == 0) {
      this.systemService.notifyInfo(this.translate.instant('Mindestens ein Feature auswählen'));
      return false;
    }

    return true
  }

  createParameterStringAsJsonString() {
    return JSON.stringify(this.selectedFeatures);
  }

  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.selectedFeatures = parsed.selectedFeatures;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
  
  public getCustomname (item: any){

    if(!item){
      return;
    }

    if (!item.unit || item.unit.trim() === "") {
      return item.name;
    }

    return `${item.name} | ${item.unit}`;
  }

}
